import React from 'react';
import { View, StyleSheet } from 'react-native';

interface MarginProps {
    m?: number | string;
    right?: number | string;
    left?: number | string;
    bottom?: number | string;
    top?: number | string;
    horizontal?: number | string;
    vertical?: number | string;
}

export function Margin({ m, right, left, bottom, top, horizontal, vertical }: MarginProps) {
    const styles = StyleSheet.create({
        theMargin: {
            //@ts-ignore
            margin: m,
            //@ts-ignore
            marginRight: right,
            //@ts-ignore
            marginLeft: left,
            //@ts-ignore
            marginBottom: bottom,
            //@ts-ignore
            marginTop: top,
            //@ts-ignore
            marginHorizontal: horizontal,
            //@ts-ignore
            marginVertical: vertical,
        },
    });

    return <View style={styles.theMargin} />;
}

export default Margin;
